import { Component } from '@angular/core';

@Component({
  selector: 'app-view-error',
  templateUrl: './Error.html',
  styleUrls: ['./style.css']
})
export class AppViewError {

}
